export default "__VITE_ASSET__5TNjv6L5__"